'use client'

import { useCallback } from 'react'
import { useOptionalTenant } from '@/contexts/TenantContext'
import { useWmtAppPlatformContext } from '@/contexts/WmtAppPlatformContext'
import { resolveExternalHref } from './resolveExternalHref'

export type ResolveExternalHrefFn = (
    href: string,
    options?: { openExternally?: boolean },
) => string

/**
 * Client helper: rewrite external navigations when Walmart native-app deeplinks
 * are enabled and `wmt-app-platform` is set.
 */
export function useResolveExternalHref(): ResolveExternalHrefFn {
    const { platform, storefrontOrigin } = useWmtAppPlatformContext()
    const tenant = useOptionalTenant()
    const nativeAppExternalDeeplinks = tenant?.capabilities?.nativeAppExternalDeeplinks === true

    return useCallback<ResolveExternalHrefFn>(
        (href, options) =>
            resolveExternalHref(href, {
                platform,
                nativeAppExternalDeeplinks,
                storefrontOrigin: storefrontOrigin || undefined,
                openExternally: options?.openExternally,
            }),
        [platform, nativeAppExternalDeeplinks, storefrontOrigin],
    )
}
